module.exports = __webpack_public_path__ + "static/media/-_Payroll.2772a09b.png";